<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container" style="width: 60%; max-height: 95vh;">
                <div class="modal-header" style="padding:15px 25px !important; padding-bottom: 0 !important;">
                    <h3 class="form-header" style="margin-left: 10px;">Adverse Drug Reactions</h3>
                    <button @click.stop="closeModal()" class="red-close-button">
                        <i class="pi pi-times" style='padding: 0'></i>
                    </button>
                </div>
                <div class="modal-body" style="padding: 0 25px;">
                    <div v-if="realAdrs.length">
                        <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
                            <thead>
                                <tr>
                                    <th style="border-bottom: 2px solid #b6b6b6; padding: 10px; text-align: left;">Drug / Agent</th>
                                    <th style="border-bottom: 2px solid #b6b6b6; padding: 10px; text-align: left;">Reaction Type</th>
                                    <th style="border-bottom: 2px solid #b6b6b6; padding: 10px; text-align: left;">Reaction Description</th>
                                    <th style="border-bottom: 2px solid #b6b6b6; padding: 10px; text-align: left;">Severity</th>
                                    <th style="border-bottom: 2px solid #b6b6b6; padding: 10px; text-align: left;">Status</th>
                                    <th style="border-bottom: 2px solid #b6b6b6; padding: 10px; text-align: left;">Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in realAdrs" :key="index" style="border-bottom: 1px solid #eee;" :style="{ opacity: item.status === 'Resolved' ? 0.55 : 1 }">
                                    <td style="padding: 10px;" :title="drugDisplayName(item).full">{{ drugDisplayName(item).short }}</td>
                                    <td style="padding: 10px;">{{ item.reaction_type ? item.reaction_type : 'N/A' }}</td>
                                    <td style="padding: 10px;">{{ item.description ? item.description : 'N/A' }}</td>
                                    <td style="padding: 10px;">{{ item.severity ? item.severity : 'N/A' }}</td>
                                    <td style="padding: 10px;">{{ item.status ? item.status : 'Active' }}</td>
                                    <td style="padding: 10px;">{{ item.date ? item.date : 'N/A' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else-if="hasNkda" style="padding: 20px; text-align: center;">
                        <p style="font-weight: bold;">No Known Drug Allergies (NKDA)</p>
                    </div>
                    <div v-else style="padding: 20px; text-align: center;">
                        <p>No Adverse Drug Reactions recorded for this patient.</p>
                    </div>
                </div>
                <div class="modal-footer" style="display: flex; justify-content: flex-end; padding: 15px 25px;">
                     <button class="black-button" style="font-weight: bold;" @click="closeModal()">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getDrugDisplayName } from '@/services/drugNames';
import { getRealAdrs, hasNkdaAssertion } from '@/services/nkda';

export default {
    props: ['patient'],
    computed: {
        realAdrs() {
            return getRealAdrs(this.patient && this.patient.adr);
        },
        hasNkda() {
            return hasNkdaAssertion(this.patient && this.patient.adr);
        },
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
        drugDisplayName(item) {
            return getDrugDisplayName(item, { fallback: 'Non Spec.', uppercase: true });
        }
    }
}
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }
</style>
